<app-collapsible-section
  [title]="title"
  [count]="itemCount"
  [defaultOpen]="itemCount <= 3"
  [forceOpen]="isEditingOrAdding">
  <div class="profile-section__content">

      <!-- LANGUAGES SECTION -->
      <ng-container *ngIf="sectionType === 'languages'">
        <!-- language rows with inline editing -->
        <ng-container *ngFor="let language of languages; let i = index">
          <!-- Show row when not being edited -->
          <app-profile-section-row
            *ngIf="editingIndex !== i"
            [title]="language.language | enumLabel: 'languages'"
            [subtitle]="getTranslatedLanguageLevel(language.level)"
            [levelMeter]="getLanguageLevelMeter(language.level)"
            [status]="null"
            [isAiParsed]="!!language.isAiParsed"
            [showSaveButton]="!!language.isAiParsed && !language.id && isAuthenticated"
            [showEditButton]="true"
            [showDeleteButton]="true"
            [hasValidationErrors]="!isLanguageValid(language)"
            [validationMessage]="getLanguageValidationMessage(language)"
            [isValid]="isLanguageValid(language)"
            (edit)="onEditLanguage(i)"
            (delete)="onDeleteLanguage(i)"
            (save)="onSaveLanguageRow(i)"></app-profile-section-row>

          <!-- Show form when this row is being edited -->
          <app-card class="profile-section__form-card" orientation="vertical" *ngIf="editingIndex === i">
            <app-languages-form
              [editingLanguage]="editingLanguage"
              [editingIndex]="editingIndex"
              [cvOptions]="cvOptions"
              (save)="onSaveLanguage($event)"
              (cancel)="onCancelLanguageForm()"></app-languages-form>
          </app-card>
        </ng-container>

        <!-- Show form for new entry -->
        <app-card class="profile-section__form-card" orientation="vertical" *ngIf="showLanguageForm && editingIndex === null">
          <app-languages-form
            [editingLanguage]="editingLanguage"
            [editingIndex]="editingIndex"
            [cvOptions]="cvOptions"
            (save)="onSaveLanguage($event)"
            (cancel)="onCancelLanguageForm()"></app-languages-form>
        </app-card>

        <!-- add language button -->
        <app-button *ngIf="!showLanguageForm" variant="outline" color="secondary" [block]="true" [icon]="true" size="lg" (click)="showLanguageForm = true">
          <i class="fas fa-plus"></i>
          {{ 'profile.profileSection.add' | transloco }}
        </app-button>
      </ng-container>

      <!-- SKILLS SECTION -->
      <ng-container *ngIf="sectionType === 'skills'">
        <!-- skill rows with inline editing -->
        <ng-container *ngFor="let skill of skills; let i = index">
          <!-- Show row when not being edited -->
          <app-profile-section-row
            *ngIf="editingIndex !== i"
            [title]="skill.skillName | enumLabel: 'skills'"
            [subtitle]="getTranslatedSkillLevel(skill.level)"
            [status]="null"
            [isAiParsed]="!!skill.isAiParsed"
            [showSaveButton]="!!skill.isAiParsed && !skill.id && isAuthenticated"
            [showEditButton]="true"
            [showDeleteButton]="true"
            [hasValidationErrors]="!isSkillValid(skill)"
            [validationMessage]="getSkillValidationMessage(skill)"
            [isValid]="isSkillValid(skill)"
            (edit)="onEditSkill(i)"
            (delete)="onDeleteSkill(i)"
            (save)="onSaveSkillRow(i)"></app-profile-section-row>

          <!-- Show form when this row is being edited -->
          <app-card class="profile-section__form-card" orientation="vertical" *ngIf="editingIndex === i">
            <app-skills-form
              [editingSkill]="editingSkill"
              [editingIndex]="editingIndex"
              [cvOptions]="cvOptions"
              (save)="onSaveSkill($event)"
              (cancel)="onCancelSkillForm()"></app-skills-form>
          </app-card>
        </ng-container>

        <!-- Show form for new entry -->
        <app-card class="profile-section__form-card" orientation="vertical" *ngIf="showSkillForm && editingIndex === null">
          <app-skills-form
            [editingSkill]="editingSkill"
            [editingIndex]="editingIndex"
            [cvOptions]="cvOptions"
            (save)="onSaveSkill($event)"
            (cancel)="onCancelSkillForm()"></app-skills-form>
        </app-card>

        <!-- add skill button -->
        <app-button *ngIf="!showSkillForm" variant="outline" color="secondary" [block]="true" [icon]="true" size="lg" (click)="showSkillForm = true">
          <i class="fas fa-plus"></i>
          {{ 'profile.profileSection.add' | transloco }}
        </app-button>
      </ng-container>

      <!-- HIGH SCHOOL EDUCATION SECTION -->
      <ng-container *ngIf="sectionType === 'highSchool'">
        <!-- high school rows with inline editing -->
        <ng-container *ngFor="let highSchool of highSchools; let i = index">
          <!-- Show row when not being edited -->
          <app-profile-section-row
            *ngIf="editingIndex !== i"
            [title]="formatSchoolName(highSchool.highSchoolName || '', highSchool.city || '', highSchool.country || '')"
            [subtitle]="highSchool.fieldOfStudy + ' | ' + formatDateDisplay(highSchool.startDate) + ' - ' + formatDateDisplay(highSchool.endDate)"
            [documentName]="highSchool.candidateAttachment?.fileName || ''"
            [status]="null"
            [isAiParsed]="!!highSchool.isAiParsed"
            [showSaveButton]="!!highSchool.isAiParsed && !highSchool.id && isAuthenticated"
            [hasAttachment]="!!highSchool.attachmentID"
            [showEditButton]="true"
            [showDeleteButton]="true"
            [hasValidationErrors]="!isHighSchoolValid(highSchool)"
            [validationMessage]="getHighSchoolValidationMessage(highSchool)"
            [isValid]="isHighSchoolValid(highSchool)"
            (edit)="onEditHighSchool(i)"
            (delete)="onDeleteHighSchool(i)"
            (save)="onSaveHighSchoolRow(i)"></app-profile-section-row>

          <!-- Show form when this row is being edited -->
          <app-card class="profile-section__form-card" orientation="vertical" *ngIf="editingIndex === i">
            <app-high-school-form
              [editingHighSchool]="editingHighSchool"
              [editingIndex]="editingIndex"
              [cvOptions]="cvOptions"
              [isAuthenticated]="isAuthenticated"
              (save)="onSaveHighSchool($event)"
              (cancel)="onCancelHighSchoolForm()"></app-high-school-form>
          </app-card>
        </ng-container>

        <!-- Show form for new entry -->
        <app-card class="profile-section__form-card" orientation="vertical" *ngIf="showHighSchoolForm && editingIndex === null">
          <app-high-school-form
            [editingHighSchool]="editingHighSchool"
            [editingIndex]="editingIndex"
            [cvOptions]="cvOptions"
            [isAuthenticated]="isAuthenticated"
            (save)="onSaveHighSchool($event)"
            (cancel)="onCancelHighSchoolForm()"></app-high-school-form>
        </app-card>

        <!-- add high school button -->
        <app-button *ngIf="!showHighSchoolForm" variant="outline" color="secondary" [block]="true" [icon]="true" size="lg" (click)="showHighSchoolForm = true">
          <i class="fas fa-plus"></i>
          {{ 'profile.profileSection.add' | transloco }}
        </app-button>
      </ng-container>

      <!-- UNIVERSITY EDUCATION SECTION -->
      <ng-container *ngIf="sectionType === 'university'">
        <!-- university rows with inline editing -->
        <ng-container *ngFor="let university of universities; let i = index">
          <!-- Show row when not being edited -->
          <app-profile-section-row
            *ngIf="editingIndex !== i"
            [title]="university.universityName || ''"
            [subtitle]="
              university.fieldOfStudy +
              ' | ' +
              formatDateDisplay(university.startDate) +
              ' - ' +
              (university.isCurrentlyStudying || university.current ? ('common.present' | transloco) : formatDateDisplay(university.endDate))
            "
            [documentName]="university.candidateAttachment?.fileName || ''"
            [status]="null"
            [isAiParsed]="!!university.isAiParsed"
            [showSaveButton]="!!university.isAiParsed && !university.id && isAuthenticated"
            [hasAttachment]="!!university.attachmentID"
            [showEditButton]="true"
            [showDeleteButton]="true"
            [hasValidationErrors]="!isUniversityValid(university)"
            [validationMessage]="getUniversityValidationMessage(university)"
            [isValid]="isUniversityValid(university)"
            (edit)="onEditUniversity(i)"
            (delete)="onDeleteUniversity(i)"
            (save)="onSaveUniversityRow(i)"></app-profile-section-row>

          <!-- Show form when this row is being edited -->
          <app-card class="profile-section__form-card" orientation="vertical" *ngIf="editingIndex === i">
            <app-university-form
              [editingUniversity]="editingUniversity"
              [cvOptions]="cvOptions"
              [isAuthenticated]="isAuthenticated"
              (save)="onSaveUniversity($event)"
              (cancel)="onCancelUniversityForm()"></app-university-form>
          </app-card>
        </ng-container>

        <!-- Show form for new entry -->
        <app-card class="profile-section__form-card" orientation="vertical" *ngIf="showUniversityForm && editingIndex === null">
          <app-university-form
            [editingUniversity]="editingUniversity"
            [cvOptions]="cvOptions"
            [isAuthenticated]="isAuthenticated"
            (save)="onSaveUniversity($event)"
            (cancel)="onCancelUniversityForm()"></app-university-form>
        </app-card>

        <!-- add university button -->
        <app-button *ngIf="!showUniversityForm" variant="outline" color="secondary" [block]="true" [icon]="true" size="lg" (click)="showUniversityForm = true">
          <i class="fas fa-plus"></i>
          {{ 'profile.profileSection.add' | transloco }}
        </app-button>
      </ng-container>

      <!-- WORK EXPERIENCE SECTION -->
      <ng-container *ngIf="sectionType === 'workExperience'">
        <!-- work experience rows with inline editing -->
        <ng-container *ngFor="let workExperience of workExperiences; let i = index">
          <!-- Show row when not being edited -->
          <app-profile-section-row
            *ngIf="editingIndex !== i"
            [title]="`${workExperience.employer} | ${workExperience.position}`"
            [subtitle]="
              (workExperience.city ? workExperience.city + ', ' : '') +
              (workExperience.country || '') +
              ' | ' +
              formatDateDisplay(workExperience.startDate) +
              ' - ' +
              (workExperience.current ? ('common.present' | transloco) : formatDateDisplay(workExperience.endDate))
            "
            [status]="null"
            [isAiParsed]="!!workExperience.isAiParsed"
            [showSaveButton]="!!workExperience.isAiParsed && !workExperience.id && isAuthenticated"
            [showEditButton]="true"
            [showDeleteButton]="true"
            [hasValidationErrors]="!isWorkExperienceValid(workExperience)"
            [validationMessage]="getWorkExperienceValidationMessage(workExperience)"
            [isValid]="isWorkExperienceValid(workExperience)"
            (edit)="onEditWorkExperience(i)"
            (delete)="onDeleteWorkExperience(i)"
            (save)="onSaveWorkExperienceRow(i)"></app-profile-section-row>

          <!-- Show form when this row is being edited -->
          <app-card class="profile-section__form-card" orientation="vertical" *ngIf="editingIndex === i">
            <app-work-experience-form
              [editingWorkExperience]="editingWorkExperience"
              [editingIndex]="editingIndex"
              (save)="onSaveWorkExperience($event)"
              (cancel)="onCancelWorkExperienceForm()"></app-work-experience-form>
          </app-card>
        </ng-container>

        <!-- Show form for new entry -->
        <app-card class="profile-section__form-card" orientation="vertical" *ngIf="showWorkExperienceForm && editingIndex === null">
          <app-work-experience-form
            [editingWorkExperience]="editingWorkExperience"
            [editingIndex]="editingIndex"
            (save)="onSaveWorkExperience($event)"
            (cancel)="onCancelWorkExperienceForm()"></app-work-experience-form>
        </app-card>

        <!-- add work experience button -->
        <app-button
          *ngIf="!showWorkExperienceForm"
          variant="outline"
          color="secondary"
          [block]="true"
          [icon]="true"
          size="lg"
          (click)="showWorkExperienceForm = true">
          <i class="fas fa-plus"></i>
          {{ 'profile.profileSection.add' | transloco }}
        </app-button>
      </ng-container>

      <!-- PROJECTS SECTION -->
      <ng-container *ngIf="sectionType === 'projects'">
        <!-- project rows with inline editing -->
        <ng-container *ngFor="let project of projects; let i = index">
          <!-- Show row when not being edited -->
          <app-profile-section-row
            *ngIf="editingIndex !== i"
            [title]="`${project.title} | ${project.position}`"
            [subtitle]="
              (project.duration !== null && project.duration !== undefined ? project.duration.toString() : '') +
              (project.country ? ' | ' + project.country : '')
            "
            [status]="null"
            [isAiParsed]="!!project.isAiParsed"
            [showSaveButton]="!!project.isAiParsed && !project.id && isAuthenticated"
            [showEditButton]="true"
            [showDeleteButton]="true"
            [hasValidationErrors]="!isProjectValid(project)"
            [validationMessage]="getProjectValidationMessage(project)"
            [isValid]="isProjectValid(project)"
            (edit)="onEditProject(i)"
            (delete)="onDeleteProject(i)"
            (save)="onSaveProjectRow(i)"></app-profile-section-row>

          <!-- Show form when this row is being edited -->
          <app-card class="profile-section__form-card" orientation="vertical" *ngIf="editingIndex === i">
            <app-project-form
              [editingProject]="editingProject"
              [editingIndex]="editingIndex"
              (save)="onSaveProject($event)"
              (cancel)="onCancelProjectForm()"></app-project-form>
          </app-card>
        </ng-container>

        <!-- Show form for new entry -->
        <app-card class="profile-section__form-card" orientation="vertical" *ngIf="showProjectForm && editingIndex === null">
          <app-project-form
            [editingProject]="editingProject"
            [editingIndex]="editingIndex"
            (save)="onSaveProject($event)"
            (cancel)="onCancelProjectForm()"></app-project-form>
        </app-card>

        <!-- add project button -->
        <app-button *ngIf="!showProjectForm" variant="outline" color="secondary" [block]="true" [icon]="true" size="lg" (click)="showProjectForm = true">
          <i class="fas fa-plus"></i>
          {{ 'profile.profileSection.add' | transloco }}
        </app-button>
      </ng-container>
    </div>
</app-collapsible-section>
